import React, { createContext, useEffect, useState, useContext } from "react";
import firebase from 'firebase/app'
import "firebase/database";
import { useAuth } from "./AuthContext";

export const UserPresenseContext = createContext();

export const useUserPresense = () => useContext(UserPresenseContext);

export const PresenseProvider = ({ children }) => {
  const [userPresense, setPresense] = useState(null);
  const { currentUser } = useAuth();
  const dbRef = firebase.database();
  const connectedRef = dbRef.ref(".info/connected");
  useEffect(() => {
    connectedRef.on("value", (snap) => {
      if (currentUser) {
        const ref = dbRef.ref(`userstatus/${currentUser.uid}`);
        setPresense(snap.val());
        if (snap.val() === true) {
          ref.set("online");
          // setPresense("online");
          ref
            .onDisconnect()
            .set("offline")
            .then(() => setPresense(false));
        }
      }
    });
  }, [userPresense]);

  const value = { userPresense };

  return (
    <UserPresenseContext.Provider value={value}>
      {children}
    </UserPresenseContext.Provider>
  );
};
